import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';

import TreatmentGroupBookingView from '@/components/TreatmentGroupBookingView';
import TreatmentGroupPicker from '@/components/TreatmentGroupPicker';
import { TREATMENT_GROUP_BOOKING_PARAM } from '@/constants/treatmentGroups';
import { TreatmentGroupForPerson } from '@/types/treatmentGroup';
import Alert from '@/ui/components/Alert';

import PersonContext from '../Person/PersonContext';

import { GroupBookingProps } from './types';

export const GroupBooking = ({ appointmentType, timeZone }: GroupBookingProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    person: { id: personId, first_name, healthie_id, jurisdiction_id }
  } = useContext(PersonContext);
  const memberFirstName = first_name ?? 'this member';

  const treatmentGroupId = searchParams.get(TREATMENT_GROUP_BOOKING_PARAM);

  if (!jurisdiction_id) {
    return (
      <div className="px-4">
        <Alert level="error">Member doesn&apos;t have a jurisdiction</Alert>
      </div>
    );
  }

  const handleSelectGroup = (group: TreatmentGroupForPerson) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set(TREATMENT_GROUP_BOOKING_PARAM, group.id);
      return next;
    });
  };

  const handleBack = () => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete(TREATMENT_GROUP_BOOKING_PARAM);
      return next;
    });
  };

  return (
    <div className="mt-6">
      {!healthie_id && (
        <div className="mb-4">
          <Alert level="warn" dismissable={false}>
            Member doesn&apos;t have a healthie account
          </Alert>
        </div>
      )}
      {treatmentGroupId ? (
        <TreatmentGroupBookingView
          memberFirstName={memberFirstName}
          onBack={handleBack}
          personId={personId}
          timeZone={timeZone}
          treatmentGroupId={treatmentGroupId}
        />
      ) : (
        <TreatmentGroupPicker
          appointmentTypeId={appointmentType.id}
          memberFirstName={memberFirstName}
          onSelectGroup={handleSelectGroup}
          personId={personId}
          timeZone={timeZone}
        />
      )}
    </div>
  );
};
